/*
  Asset hero background video. The still stays the LCP image; the video only starts loading after
  window load plus the section's delay, then fades in over it. When the video ends it fades back to
  the still, holds for data-hold seconds, and fades in again from the start. Skipped for reduced
  motion, data saver and 2g connections, where the still simply stays.
*/
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var connection = navigator.connection;
  if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ''))) return;

  function setup(video) {
    var hero = video.parentElement;
    var toggle = hero.querySelector('.asset-hero__video-toggle');
    var delay = (parseFloat(video.dataset.delay) || 0) * 1000;
    var hold = (parseFloat(video.dataset.hold) || 0) * 1000;
    var userPaused = false;
    var inView = true;
    var holdTimer = null;
    var started = false;

    video.loop = false;

    function play() {
      var promise = video.play();
      return promise && promise.catch ? promise : Promise.resolve();
    }

    // Plays and fades in. Does nothing while the still is holding between plays.
    function resume() {
      if (holdTimer || userPaused || !inView) return;
      play()
        .then(function () {
          video.classList.add('is-playing');
        })
        .catch(function () {});
    }

    function setPaused(paused) {
      userPaused = paused;
      if (!toggle) return;
      toggle.classList.toggle('is-paused', paused);
      toggle.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        inView = entry.isIntersecting;
        if (inView) resume();
        else video.pause();
      });
    });

    video.addEventListener('ended', function () {
      video.classList.remove('is-playing');
      holdTimer = window.setTimeout(function () {
        holdTimer = null;
        video.currentTime = 0;
        resume();
      }, hold);
    });

    function start() {
      if (started) return;
      started = true;
      var desktop = window.matchMedia('(min-width: 750px)').matches;
      video.src = desktop ? video.dataset.src : video.dataset.srcMobile || video.dataset.src;
      video.addEventListener(
        'canplay',
        function () {
          play()
            .then(function () {
              video.classList.add('is-playing');
              if (toggle) toggle.hidden = false;
              observer.observe(hero);
            })
            .catch(function () {});
        },
        { once: true }
      );
      video.load();
    }

    // The button's is-paused class (set in setPaused) is what shows it, centred on the video.
    function togglePause() {
      if (userPaused) {
        setPaused(false);
        resume();
      } else {
        setPaused(true);
        video.pause();
      }
    }

    if (toggle) toggle.addEventListener('click', togglePause);

    // A click anywhere on the hero except its links and buttons does the same as the corner button.
    hero.addEventListener('click', function (event) {
      if (!started || (toggle && toggle.hidden)) return;
      if (event.target.closest('a, button, input, select, textarea, label')) return;
      togglePause();
    });

    function schedule() {
      window.setTimeout(start, delay);
    }
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
  }

  function init() {
    document.querySelectorAll('video[class^="asset-hero-"][data-src]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
